function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import uuid from './uuid';
import get from './get';
export var unique = uuid();
var uniqueId = function uniqueId(id) {
  return "".concat(id, "-").concat(unique);
};
function join() {
  for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }
  return parts.filter(function (part) {
    return !!part;
  }).join(' ');
}
function isGroup(item) {
  return item.type === 'group' && item.children;
}
var DATE_PREFIXES = ['dty', 'dtm', 'dtd'];
function isDateGroup(item) {
  if (isGroup(item)) {
    return !item.children.find(function (child) {
      if (child.type === 'field') {
        return !DATE_PREFIXES.includes(child.id.substring(0, 3));
      }
      return false;
    });
  }
  return false;
}
function isAuthorGroup(item) {
  return item.id === 'intellcont_auth';
}
export default function (_ref, config) {
  var uiSchema = _ref.uiSchema,
    schema = _ref.schema,
    formData = _ref.formData,
    rest = _objectWithoutProperties(_ref, ["uiSchema", "schema", "formData"]);
  var groupUiSchema = {
    'dm:layout': []
  };
  var groupSchema = {
    properties: {}
  };
  var groupFormData = {};

  // Create new groups
  config.order.forEach(function (id) {
    var groupId = uniqueId(id);
    groupUiSchema[groupId] = {
      'ui:title': {
        text: config.titles[id],
        escape: false
      },
      'ui:options': {
        compact: false
      }
    };
    groupUiSchema['dm:layout'].push({
      id: groupId,
      type: 'group',
      children: []
    });
  });

  // Add Fields
  var groupIdx = 0;
  uiSchema['dm:layout'].forEach(function (item) {
    if (item.type === 'text') {
      return;
    }
    if (isAuthorGroup(item)) {
      var dsa = uiSchema[item.id];
      var layout = dsa.items['dm:layout'];
      var facultyName = layout.find(function (item) {
        return item.id === 'faculty_name';
      });
      if (facultyName) {
        layout = layout.filter(function (item) {
          return item.id !== 'faculty_name';
        });
        layout.push(facultyName);
        groupUiSchema[item.id] = _objectSpread({}, uiSchema[item.id], {
          items: _objectSpread({}, dsa.items, _defineProperty({}, 'dm:layout', layout))
        });
      }
    }

    // Cards
    //   0: Everything before intellcont_auth
    //   1: intellcont_auth
    //   2: Everything after intellcont_auth
    if (isAuthorGroup(item)) {
      groupIdx = 1;
    } else if (groupIdx === 1) {
      groupIdx = 2;
    }
    var group = groupUiSchema['dm:layout'][groupIdx];
    // Date Fields
    if (isDateGroup(item) && config.collapseDateGroups) {
      var title = uiSchema[item.id]['ui:title'].text;
      var dateId = uniqueId(item.id);
      groupUiSchema[dateId] = {
        'ui:title': {
          text: title,
          escape: false
        },
        'ui:widget': 'text'
      };
      group.children.push({
        id: dateId,
        type: 'field'
      });
      groupSchema.properties[dateId] = {
        title: title,
        type: 'string'
      };
      var data = item.children.map(function (child) {
        var prop = schema.properties[child.id];
        var value = formData[child.id];
        if (prop && value && prop.enum && prop.enum.length > 0 && prop.enum.indexOf(value) >= 0 && prop.enumNames && prop.enumNames.length > 0 && prop.enumNames[prop.enum.indexOf(value)]) {
          return prop.enumNames[prop.enum.indexOf(value)];
        } else if (prop && prop['$ref']) {
          var ref = prop['$ref'].replace('#/', '').replaceAll('/', '.');
          var def = get(ref)(schema);
          var index = def.enum.indexOf(value);
          return def.enumNames[index];
        }
        return value;
      });
      groupFormData[dateId] = data.filter(function (datum) {
        return !!datum;
      }).join(' ');
    } else if (isAuthorGroup(item) && config.collapseAuthors) {
      group.children.push(item);
      var _layout = [{
        id: "name-".concat(unique),
        type: 'field'
      }];
      schema.properties[item.id].items.properties["name-".concat(unique)] = {
        title: config.titles.name,
        type: 'string'
      };
      groupFormData[item.id] = formData[item.id].map(function (fd) {
        return _objectSpread({}, fd, _defineProperty({}, "name-".concat(unique), join.apply(void 0, _toConsumableArray(['fname', 'mname', 'lname'].map(function (field) {
          return fd[field];
        })))));
      });
      groupUiSchema[item.id] = {
        items: {
          'dm:layout': _layout
        },
        'ui:options': {
          itemName: config.titles.author
        }
      };
    } else {
      group.children.push(item);
    }
  });

  // Remove empty groups
  config.order.forEach(function (id) {
    var groupId = uniqueId(id);
    var layout = groupUiSchema['dm:layout'];
    if (layout.find(function (item) {
      return item.id === groupId;
    }).children.length === 0) {
      groupUiSchema['dm:layout'] = layout.filter(function (item) {
        return item.id !== groupId;
      });
      delete groupUiSchema[groupId];
    }
  });
  return _objectSpread({
    uiSchema: _objectSpread({}, uiSchema, groupUiSchema, config.uiSchema),
    schema: _objectSpread({}, schema, {
      properties: _objectSpread({}, schema.properties, groupSchema.properties)
    }),
    formData: _objectSpread({}, formData, groupFormData)
  }, rest);
}